
import { ArrowLeft } from 'lucide-react';
import ImmigrantsCounter from '../ImmigrantsCounter';
import { useIsMobile } from '@/hooks/use-mobile';
import { Link } from 'react-router-dom';

const AuthHeader = () => {
  const isMobile = useIsMobile();
  
  return (
    <header className="relative bg-primary text-white py-6 pb-16 md:py-8 md:pb-20 overflow-hidden">
      {/* Back button to landing page */}
      <div className="absolute top-4 left-4 z-20">
        <Link 
          to="/landing" 
          className="flex items-center gap-1 text-white hover:text-white/80 transition-colors"
        >
          <ArrowLeft className="h-4 w-4" />
          <span>Volver</span>
        </Link>
      </div>
      
      {/* Background Image Overlay */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-40 brightness-110"
        style={{
          backgroundImage: 'url("/lovable-uploads/e2e39701-504e-4674-b171-f52185261c7a.png")',
          backgroundPosition: 'center top',
          backgroundSize: 'cover'
        }}
      />
      
      {/* Warm Gradient Overlay */}
      <div 
        className="absolute inset-0 bg-gradient-to-b from-primary/30 to-primary/60 mix-blend-multiply"
        aria-hidden="true"
      />
      
      {/* Content */}
      <div className="container mx-auto px-4 relative z-10">
        <div className="flex flex-col items-center gap-3 md:gap-4">
          {/* Reduced empty space */}
          <div className={`${isMobile ? 'h-10' : 'h-16'} flex items-center justify-center`} />
          
          <h1 className="text-2xl md:text-4xl font-bold text-center px-2 [text-shadow:_0_1px_2px_rgba(0,0,0,0.3)]">
            ¿Tienes dudas sobre inmigración? Recibe ayuda en minutos.
          </h1>
          
          <p className="text-center mt-2 max-w-2xl mx-auto px-2 text-sm md:text-base [text-shadow:_0_1px_1px_rgba(0,0,0,0.2)]">
            Recibe tu guía paso a paso en tu proceso migratorio con respuestas claras y seguras.
          </p>
          
          {/* Space below the text content */}
          <div className="mt-4">
            <ImmigrantsCounter />
          </div>
        </div>
      </div>
    </header>
  );
};

export default AuthHeader;
